// extracted by mini-css-extract-plugin
export default {"title":"SideBarArticle_title__iNmVM"};